import { Actions, ActionTypes } from '@appStore/account/actions';
import { Notification } from '../../../models/notification.model';

export interface State {
  loading: boolean;
  loaded: boolean;
  removing: boolean;
  removed: boolean;
  bulkRemoving: boolean;
  bulkRemoved: boolean;
  intervalLoading: boolean;
  intervalLoaded: boolean;
  unreadCountLoading: boolean;
  unreadCountLoaded: boolean;
  unreadCount: number;
  countLoading: boolean;
  countLoaded: boolean;
  count: number;
  data: Notification[];
}

export const initialState: State = {
  loading: false,
  loaded: false,
  removing: false,
  removed: false,
  bulkRemoving: false,
  bulkRemoved: false,
  intervalLoading: false,
  intervalLoaded: false,
  unreadCountLoading: false,
  unreadCountLoaded: false,
  unreadCount: 0,
  countLoading: false,
  countLoaded: false,
  count: 0,
  data: []
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.NotificationLoadData:
      return { ...state, loaded: false, loading: true };
    case ActionTypes.NotificationLoadDataSuccess:
      return { ...state, loaded: true, loading: false, data: action.payload };
    case ActionTypes.NotificationLoadDataFail:
      return { ...state, loaded: false, loading: false };

    case ActionTypes.NotificationRemove:
      return { ...state, removed: false, removing: true };
    case ActionTypes.NotificationRemoveSuccess:
      const oldItem = action.payload;
      return {
        ...state,
        removed: true,
        removing: false,
        data: state.data.filter(item => item.id !== oldItem.id)
      };
    case ActionTypes.NotificationRemoveFail:
      return {
        ...state,
        removed: false,
        removing: false
      };

    case ActionTypes.NotificationBulkRemove:
      return { ...state, bulkRemoved: false, bulkRemoving: true };
    case ActionTypes.NotificationBulkRemoveSuccess:
      const oldItems = action.payload;
      return {
        ...state,
        bulkRemoved: true,
        bulkRemoving: false,
        data: state.data.filter(item => !oldItems.some(x => x === item.id))
      };
    case ActionTypes.NotificationBulkRemoveFail:
      return {
        ...state,
        bulkRemoved: false,
        bulkRemoving: false
      };

    case ActionTypes.NotificationLoadUnreadCount:
      return { ...state, unreadCountLoaded: false, unreadCountLoading: true };
    case ActionTypes.NotificationLoadUnreadCountSuccess:
      return { ...state, unreadCount: action.payload, unreadCountLoaded: true, unreadCountLoading: false };
    case ActionTypes.NotificationLoadUnreadCountFail:
      return { ...state, unreadCount: 0, unreadCountLoaded: false, unreadCountLoading: false };

    case ActionTypes.NotificationLoadCount:
      return { ...state, countLoaded: false, countLoading: true };

    case ActionTypes.NotificationLoadCountSuccess:
      return { ...state, count: action.payload, countLoaded: true, countLoading: false };

    case ActionTypes.NotificationLoadCountFail:
      return { ...state, count: 0, countLoaded: false, countLoading: false };

    case ActionTypes.NotificationSetAsReadSuccess:
      const newItem = action.payload;
      return { 
        ...state, 
        data: state.data.map(item => (item.id === newItem.id ? newItem : item)),
        unreadCount: state.data.filter(x => x.unread).length // Only items that have changed are returned
      };

    case ActionTypes.NotificationIntervalSetAsReadSuccess:
      const resultItems = action.payload;
      let data = state.data.map(item => {
        let resultItem = resultItems.find(n => n.id === item.id);
        return resultItem ? resultItem : item;
      });
      return {
        ...state,
        data: data,
        unreadCount: data.filter(x => x.unread).length // Only items that have changed are returned
      };

    case ActionTypes.NotificationIntervalLoadData:
      return { ...state, intervalLoaded: false, intervalLoading: true };

    case ActionTypes.NotificationIntervalLoadDataSuccess:
      const newItems = action.payload.filter(x => state.data.every(y => y.id !== x.id));
      return { ...state, intervalLoaded: true, intervalLoading: false, data: [...state.data, ...newItems] };

    case ActionTypes.NotificationIntervalLoadDataFail:
      return { ...state, intervalLoaded: false, intervalLoading: false };
  }
  return state;
}

export const getAll = (state: State) => state.data;
export const getAllUnread = (state: State) => state.data.filter(not => not.unread === true);
export const getAllRead = (state: State) => state.data.filter(not => not.unread !== true);
export const getLoaded = (state: State) => state.loaded;
export const getLoading = (state: State) => state.loading;
export const getUnreadCount = (state: State) => state.unreadCount;
export const getUnreadCountLoaded = (state: State) => state.unreadCountLoaded;
export const getUnreadCountLoading = (state: State) => state.unreadCountLoading;
export const getCount = (state: State) => state.count;
export const getCountLoaded = (state: State) => state.countLoaded;
export const getCountLoading = (state: State) => state.countLoading;
export const getIntervalLoaded = (state: State) => state.intervalLoaded;
export const getIntervalLoading = (state: State) => state.intervalLoading;
export const getItemRemoved = (state: State) => state.removed;
export const getItemRemoving = (state: State) => state.removing;
export const getItemsRemoved = (state: State) => state.bulkRemoved;
export const getItemsRemoving = (state: State) => state.bulkRemoving;
